import React from "react";
import { Heading } from "@chakra-ui/react";

export const Navbar = () => {
  return (
    <div className="navbar navbar-expand-lg bg-light fixed-top">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          <Heading>
            <span style={{ color: "rgb(220, 20, 60)" }}> ROH</span>AAN
          </Heading>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item font-weight-bold">
              <a className="nav-link font-weight-bold buttom-border" href="#home">
                <strong>HOME</strong>
              </a>
            </li>

            <li className="nav-item font-weight-bold">
              <a className="nav-link font-weight-bold buttom-border" href="#about">
                <strong>ABOUT</strong>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link buttom-border" href="#education">
                <strong>EDUCATION</strong>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link buttom-border" href="#project">
                <strong>PROJECT</strong>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link buttom-border" href="#skill">
                <strong>SKILL</strong>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link buttom-border" href="#contact">
                <strong>CONTACT</strong>
              </a>
            </li>
            <a href="/assets/Rohaan_Telangur_Resume.pdf" target="_blank">
              <button type="button" className="fw-bold btn btn-danger">
                RESUME
              </button>
            </a>
          </ul>
        </div>
      </div>
    </div>
  );
};
